module.exports = __webpack_public_path__ + "img/existing-data.8d791886.svg";